/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_Booking_Times_Code_Example_1Inputs */

const en_admin_resource_form_booking_times_code_example_1 = /** @type {(inputs: Admin_Resource_Form_Booking_Times_Code_Example_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mo - su 7am - 9pm`)
};

const de_admin_resource_form_booking_times_code_example_1 = /** @type {(inputs: Admin_Resource_Form_Booking_Times_Code_Example_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mo - su 7am - 9pm`)
};

const es_admin_resource_form_booking_times_code_example_1 = /** @type {(inputs: Admin_Resource_Form_Booking_Times_Code_Example_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mo - su 7am - 9pm`)
};

const fr_admin_resource_form_booking_times_code_example_1 = /** @type {(inputs: Admin_Resource_Form_Booking_Times_Code_Example_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mo - su 7am - 9pm`)
};

const nl_admin_resource_form_booking_times_code_example_1 = /** @type {(inputs: Admin_Resource_Form_Booking_Times_Code_Example_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mo - su 7am - 9pm`)
};

/** @type {(inputs: Admin_Resource_Form_Booking_Times_Code_Example_1Inputs) => LocalizedString} */
const it_admin_resource_form_booking_times_code_example_1 = en_admin_resource_form_booking_times_code_example_1;

/** @type {(inputs: Admin_Resource_Form_Booking_Times_Code_Example_1Inputs) => LocalizedString} */
const pt_br2_admin_resource_form_booking_times_code_example_1 = en_admin_resource_form_booking_times_code_example_1;

/** @type {(inputs: Admin_Resource_Form_Booking_Times_Code_Example_1Inputs) => LocalizedString} */
const pl_admin_resource_form_booking_times_code_example_1 = en_admin_resource_form_booking_times_code_example_1;

/** @type {(inputs: Admin_Resource_Form_Booking_Times_Code_Example_1Inputs) => LocalizedString} */
const hu_admin_resource_form_booking_times_code_example_1 = en_admin_resource_form_booking_times_code_example_1;

/** @type {(inputs: Admin_Resource_Form_Booking_Times_Code_Example_1Inputs) => LocalizedString} */
const ro_admin_resource_form_booking_times_code_example_1 = en_admin_resource_form_booking_times_code_example_1;

/**
* | output |
* | --- |
* | "mo - su 7am - 9pm" |
*
* @param {Admin_Resource_Form_Booking_Times_Code_Example_1Inputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_booking_times_code_example_1 = /** @type {((inputs?: Admin_Resource_Form_Booking_Times_Code_Example_1Inputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_Booking_Times_Code_Example_1Inputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_booking_times_code_example_1(inputs)
	if (locale === "de") return de_admin_resource_form_booking_times_code_example_1(inputs)
	if (locale === "es") return es_admin_resource_form_booking_times_code_example_1(inputs)
	if (locale === "fr") return fr_admin_resource_form_booking_times_code_example_1(inputs)
	if (locale === "nl") return nl_admin_resource_form_booking_times_code_example_1(inputs)
	if (locale === "it") return it_admin_resource_form_booking_times_code_example_1(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_booking_times_code_example_1(inputs)
	if (locale === "pl") return pl_admin_resource_form_booking_times_code_example_1(inputs)
	if (locale === "hu") return hu_admin_resource_form_booking_times_code_example_1(inputs)
	return ro_admin_resource_form_booking_times_code_example_1(inputs)
});
export { admin_resource_form_booking_times_code_example_1 as "admin.resource_form.booking_times_code_example_1" }